import React, { useState, useEffect } from 'react';
// import Header from '../../../Common/header';
import Sidebar from '../../../Common/Sidebar';
import { useNavigate } from 'react-router-dom';
import CustomLoader from '../../../Components/CustomLoader/CustomLoader';
import Header from '../../../Common/Header';

function BookingManagementList() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  useEffect(() => {
    // Mock data loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleButtonClick = () => {
    navigate('/add-booking'); // Navigate to the About page
  };

  const tableData = [
    {
      id: 1,
      User: { name: 'Create A New React app', image: '/src./assets/images/users/user.jpg' },
      status: { text: 'In-Progress', class: 'bg-warning-subtle text-warning' },
      assignedTo: 'Alexander White',
      deadline: 'Due in 3 days',
      priority: 'High',
    },
    {
      id: 2,
      User: { name: 'Finish project report', image: '/src./assets/images/users/user-2.jpg' },
      status: { text: 'Pending', class: 'bg-primary-subtle text-primary' },
      assignedTo: 'Sophia Williams',
      deadline: '15 August 2024',
      priority: 'Medium',
    },
    {
      id: 3,
      User: { name: 'Finish project report', image: '/src./assets/images/users/user-3.jpg' },
      status: { text: 'Completed', class: 'bg-success-subtle text-success' },
      assignedTo: 'Sophia Williams',
      deadline: '15 August 2024',
      priority: 'Medium',
    },
    {
      id: 4,
      User: { name: 'Finish project report', image: '/src./assets/images/users/user-4.jpg' },
      status: { text: 'In-Progress', class: 'bg-warning-subtle text-warning' },
      assignedTo: 'Sophia Williams',
      deadline: '15 August 2024',
      priority: 'Medium',
    },
    {
      id: 2,
      User: { name: 'Finish project report', image: '/src./assets/images/users/user-5.jpg' },
      status: { text: 'Pending', class: 'bg-primary-subtle text-primary' },
      assignedTo: 'Sophia Williams',
      deadline: '15 August 2024',
      priority: 'Medium',
    },
    {
      id: 2,
      User: { name: 'Finish project report', image: '/src./assets/images/users/user-6.jpg' },
      status: { text: 'Pending', class: 'bg-primary-subtle text-primary' },
      assignedTo: 'Sophia Williams',
      deadline: '15 August 2024',
      priority: 'Medium',
    },
    {
      id: 2,
      User: { name: 'Finish project report', image: '/src./assets/images/users/user-7.jpg' },
      status: { text: 'Pending', class: 'bg-primary-subtle text-primary' },
      assignedTo: 'Sophia Williams',
      deadline: '15 August 2024',
      priority: 'Medium',
    },
    {
      id: 2,
      User: { name: 'Finish project report', image: '/src./assets/images/users/user-8.jpg' },
      status: { text: 'Pending', class: 'bg-primary-subtle text-primary' },
      assignedTo: 'Sophia Williams',
      deadline: '15 August 2024',
      priority: 'Medium',
    },
    {
      id: 2,
      User: { name: 'Finish project report', image: '/src./assets/images/users/user-9.jpg' },
      status: { text: 'Pending', class: 'bg-primary-subtle text-primary' },
      assignedTo: 'Sophia Williams',
      deadline: '15 August 2024',
      priority: 'Medium',
    },
    {
      id: 2,
      User: { name: 'Finish project report', image: '/src./assets/images/users/user-10.jpg' },
      status: { text: 'Pending', class: 'bg-primary-subtle text-primary' },
      assignedTo: 'Sophia Williams',
      deadline: '15 August 2024',
      priority: 'Medium',
    },
    // Add more rows as needed
  ];

  // State for selected checkboxes
  const [selectedRows, setSelectedRows] = useState([]);

  // State for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 5; // Number of rows per page

  // Handle checkbox selection
  const handleCheckboxChange = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  // Handle select all checkboxes
  const handleSelectAll = () => {
    if (selectedRows.length === tableData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(tableData.map((row) => row.id));
    }
  };

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = tableData.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <Header />
      <Sidebar />
      <div className="content-page">
        <CustomLoader loading={loading} />
        <div className="content">
          <div className="container-fluid">
            {!loading && (
              <div className="row">
                <div className="col-12">
                  <div className="card" style={{ background: "none" }}>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-centered table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={selectedRows.length === tableData.length}
                                  onChange={handleSelectAll}
                                />
                              </th>
                              <th>User</th>
                              <th>Status</th>
                              <th>Assigned To</th>
                              <th>Deadline</th>
                              <th>Priority</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentRows.map((row) => (
                              <tr key={row.id}>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedRows.includes(row.id)}
                                    onChange={() => handleCheckboxChange(row.id)}
                                  />
                                </td>
                                <td className="ps-0">
                                  <img
                                    src={row.User.image}
                                    alt=""
                                    className="thumb-md me-2 rounded-circle avatar-border"
                                  />
                                  <p className="d-inline-block align-middle mb-0">
                                    <span>{row.User.name}</span>
                                  </p>
                                </td>
                                <td>
                                  <span className={`badge ${row.status.class}`}>
                                    {row.status.text}
                                  </span>
                                </td>
                                <td>{row.assignedTo}</td>
                                <td>{row.deadline}</td>
                                <td>{row.priority}</td>
                                <td className="text-end">
                                  <a
                                    aria-label="anchor"
                                    className="btn btn-sm bg-primary-subtle me-1"
                                    data-bs-toggle="tooltip"
                                    data-bs-original-title="Edit"
                                  >
                                    <i className="mdi mdi-pencil-outline fs-14 text-primary"></i>
                                  </a>
                                  <a
                                    aria-label="anchor"
                                    className="btn btn-sm bg-danger-subtle"
                                    data-bs-toggle="tooltip"
                                    data-bs-original-title="Delete"
                                  >
                                    <i className="mdi mdi-delete fs-14 text-danger"></i>
                                  </a>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Pagination */}
                        <nav>
                          <ul className="pagination justify-content-end">
                            {Array.from({ length: Math.ceil(tableData.length / rowsPerPage) }).map(
                              (_, index) => (
                                <li
                                  key={index}
                                  className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                                >
                                  <button className="page-link" onClick={() => paginate(index + 1)}>
                                    {index + 1}
                                  </button>
                                </li>
                              )
                            )}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default BookingManagementList;